export default __webpack_public_path__ + "static/media/2.94843f47.jpg";